import { render } from "./BulkSkipTracking.vue?vue&type=template&id=2f9489f8&scoped=true"
import script from "./BulkSkipTracking.vue?vue&type=script&lang=ts"
export * from "./BulkSkipTracking.vue?vue&type=script&lang=ts"

import "./BulkSkipTracking.vue?vue&type=style&index=0&id=2f9489f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f9489f8"

export default script